import { LAYOUTS, POSITION } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { redirectDashboard, retryPayment, retryInterestCollectionPayment, retryPaymentForeclosure, retryPaymentForExpiredLoan, retryPaymentShortfall } from "./action";
import { ACTION, PaymentStatuses } from "./types";
import { addCommasToNumber, getPaymentMode, getRepaymentExpectedDateBy, removePathFromUrlWithouReload, removeURLParams, removeUrlWithoutReload } from "../../../configs/utils";
import { Platform } from "react-native";
import sharedPropsService from "../../../SharedPropsService";
import { LENDER_ID, REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
import SharedPropsService from '../../../SharedPropsService';
export const template = async (amountCollected, transactionalRefNumber, bankRefNumber, paymentMode, paymentDate, isPaymentSuccessful, isPaymentFailure, isPaymentPending, isPaymentCancelled, isFromForeclosure, showDetailBanner, isFromLoanRenewal, stepperData, height, currentLender, isFromInterestRepay, isFromInterestCollection, isFromShortfall, dspPaymentStatus, currentOrderId, dspAmountCollected, dspPaymentDate, redirectingRoute) => {
    return {
        layout: {
            id: ROUTE.PAYMENT_CALLBACK,
            type: LAYOUTS.LIST,
            widgets: [
                dspPaymentStatus !== undefined ? { id: "dspPaymentScreen", type: WIDGET.DSP_PAYMENT_SCREEN } :
                    (isPaymentSuccessful && currentLender?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()) ? { id: "paymentSuccessFullScreen", type: WIDGET.PAYMENT_SUCCESSFULL_SCREEN } :
                        { id: "containerStack", type: WIDGET.STACK }
            ],
        },
        datastore: {
            containerStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    isPaymentSuccessful ? { id: "successLottie", type: WIDGET.LOTTIE } : { id: "icon", type: WIDGET.ICON },
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    { id: "paymentStatus", type: WIDGET.TEXT },
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "paymentAmount", type: WIDGET.TEXT },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "paymentData", type: WIDGET.TEXT },
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    isPaymentPending ? { id: "failureNote", type: WIDGET.FAILURE_NOTE } : {},
                    (isPaymentCancelled || isPaymentFailure) ? { id: "failureNote", type: WIDGET.FAILURE_NOTE } : {},
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    { id: "paymentDetailsStack", type: WIDGET.STACK },
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    { id: "proceedCTA", type: WIDGET.BUTTON, position: POSITION.ABSOLUTE_BOTTOM },
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    isPaymentFailure || isPaymentCancelled ? { id: "skipPaymentForNowStack", type: WIDGET.STACK } : {}
                ]
            },
            dspPaymentScreen: {
                height: height - 16,
                dspPaymentStatus,
                currentOrderId,
                dspAmountCollected,
                paymentDate,
                dspPaymentDate,
                navigateDashboardAction: {
                    routeId: ROUTE.PAYMENT_CALLBACK,
                    type: ACTION.REDIRECT_ACTION,
                },
                retryPaymentAction: {
                    routeId: ROUTE.PAYMENT_CALLBACK,
                    type: redirectingRoute === ROUTE.OUTSTANDING_DUES ? ACTION.RETRY_PAYMENT_FORECLOSURE : redirectingRoute === ROUTE.INTEREST_REPAYMENT_DETAILS ? ACTION.RETRY_INTEREST_COLLECTION_PAYMENT : redirectingRoute === ROUTE.SHORTFALL_REPAY_SCREEN ? ACTION.RETRY_PAYMENT_SHORTFALL : ACTION.RETRY_PAYMENT,
                },
            },
            paymentSuccessFullScreen: {
                height,
                stepperData,
                amountCollected,
                transactionalRefNumber,
                paymentMode,
                navigateAction: {
                    routeId: ROUTE.PAYMENT_CALLBACK,
                    type: ACTION.REDIRECT_ACTION,
                }
            },
            icon: {
                name: isPaymentSuccessful ?
                    IconTokens.Success
                    : isPaymentFailure || isPaymentCancelled
                        ? IconTokens.FailedNew
                        : IconTokens.PendingRepay,
                size: IconSizeTokens.XXXXXXXXL
            },
            successLottie: {
                uri: LottieTokens.PaymentSuccess,
                size: LottieSizeTokens.Size_80,
                loop: true,
                autoplay: true
            },
            spaceXL: {
                size: SizeTypeTokens.XL
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            spaceXXXL: {
                size: SizeTypeTokens.XXXL,
            },
            spaceXXXXL: {
                size: SizeTypeTokens.XXXXL,
            },
            spaceXXXXXL: {
                size: SizeTypeTokens.XXXXXL
            },
            titleStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "space32", type: WIDGET.SPACE },
                    { id: "titleText", type: WIDGET.TEXT, padding: {
                            right: 16
                        } }
                ],
            },
            selectFullAmountStack: {
                type: StackType.row,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "fullAmountRadioButton", type: WIDGET.RADIO },
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    { id: "fullAmountStack", type: WIDGET.STACK },
                ]
            },
            spaceXS: {
                size: SizeTypeTokens.XS
            },
            fullAmountRadioButton: {
                color: ColorTokens.Primary_100,
                isChecked: true,
                size: IconSizeTokens.XXL,
            },
            partialAmountRadioButton: {
                color: ColorTokens.Primary_100,
                isChecked: false,
                size: IconSizeTokens.XXL,
            },
            fullAmountStack: {
                type: StackType.column,
                width: StackWidth.CONTENT,
                height: StackHeight.CONTENT,
                widgetItems: [
                    { id: "fullAmountText", type: WIDGET.TEXT },
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "fullAmountValue", type: WIDGET.TEXT },
                    {
                        id: "spaceXXXL",
                        type: WIDGET.SPACE
                    },
                ]
            },
            partialAmountFullStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    {
                        id: "spaceXXXL",
                        type: WIDGET.SPACE
                    },
                    {
                        id: "selectPartialAmountStack", type: WIDGET.STACK
                    }
                ]
            },
            selectPartialAmountStack: {
                type: StackType.row,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "partialAmountRadioButton", type: WIDGET.RADIO },
                    { id: "spaceXXL", type: WIDGET.SPACE },
                    { id: "partialAmountText", type: WIDGET.TEXT }
                ]
            },
            divider: {
                size: DividerSizeTokens.MD,
                margin: {
                    all: SizeTypeTokens.XL
                },
                color: ColorTokens.Grey_Milk
            },
            spaceSM: {
                size: SizeTypeTokens.SM
            },
            spaceLG: {
                size: SizeTypeTokens.LG
            },
            enterAmountFullStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                padding: {
                    left: SizeTypeTokens.XXXXXL,
                    right: SizeTypeTokens.XXXXXL
                },
                marginRight: 90,
                widgetItems: [
                    { id: "enterAmountInputStack", type: WIDGET.STACK },
                    { id: "spaceLG", type: WIDGET.SPACE },
                    { id: "partialAmountDescription", type: WIDGET.TEXT },
                    {
                        id: "proceedButtonStack",
                        type: WIDGET.STACK
                    }
                ]
            },
            enterAmountInputStack: {
                type: StackType.row,
                padding: {
                    top: SizeTypeTokens.XXL,
                },
                widgetItems: [
                    { id: "input", type: WIDGET.INPUT },
                ]
            },
            proceedCTA: {
                label: isPaymentSuccessful || isPaymentPending ?
                    "Done"
                    : isPaymentFailure || isPaymentCancelled
                        ? "Retry payment"
                        : "Done",
                fontWeight: "700",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                justifyContent: StackJustifyContent.center,
                alignSelf: StackSelfContent.center,
                action: {
                    payload: {},
                    type: (isPaymentSuccessful && isFromLoanRenewal)
                        ? ACTION.REDIRECT_ACTION
                        : isFromLoanRenewal
                            ? ACTION.RETRY_PAYMENT_LOAN_EXPIRED
                            : (isPaymentSuccessful || isPaymentPending)
                                ? ACTION.REDIRECT_ACTION
                                : isFromInterestRepay
                                    ? ACTION.RETRY_PAYMENT
                                    : isFromInterestCollection ?
                                        ACTION.RETRY_INTEREST_COLLECTION_PAYMENT
                                        : isFromShortfall
                                            ? ACTION.RETRY_PAYMENT_SHORTFALL
                                            : isFromForeclosure
                                                ? ACTION.RETRY_PAYMENT_FORECLOSURE
                                                : ACTION.RETRY_PAYMENT,
                    routeId: ROUTE.PAYMENT_CALLBACK
                }
            },
            paymentStatus: {
                label: isPaymentSuccessful ?
                    'Payment successful'
                    : isPaymentFailure
                        ? 'Payment failed'
                        : isPaymentCancelled
                            ? "Payment failed"
                            : 'Payment in progress',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter
            },
            paymentAmount: {
                label: `${amountCollected}`,
                fontSize: FontSizeTokens.XXXXL,
                fontWeight: '900',
                lineHeight: 40,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Black
            },
            paymentData: {
                label: `${paymentDate}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter
            },
            paymentDetailsStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                bgColor: ColorTokens.Grey_Milk,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR4
                },
                padding: {
                    left: SizeTypeTokens.XXL
                },
                widgetItems: [
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "transactionNumberTitle", type: WIDGET.TEXT },
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "transactionNumberValue", type: WIDGET.TEXT },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "bankReferenceTitle", type: WIDGET.TEXT },
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "bankReferenceValue", type: WIDGET.TEXT },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "paymentMethodTitle", type: WIDGET.TEXT },
                    { id: "spaceSM", type: WIDGET.SPACE },
                    { id: "paymentMethodValue", type: WIDGET.TEXT },
                    { id: "spaceXL", type: WIDGET.SPACE },
                ]
            },
            transactionNumberTitle: {
                label: 'Transaction reference number',
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Charcoal
            },
            transactionNumberValue: {
                label: `${transactionalRefNumber}`,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night
            },
            bankReferenceTitle: {
                label: 'Bank reference number',
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Charcoal
            },
            bankReferenceValue: {
                label: `${bankRefNumber}`,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night
            },
            paymentMethodTitle: {
                label: 'Payment Method',
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Charcoal
            },
            paymentMethodValue: {
                label: `${getPaymentMode(paymentMode)}`,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night
            },
            skipPaymentForNowStack: {
                type: StackType.column,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                alignContent: StackAlignContent.center,
                widgetItems: [
                    { id: "skipPaymentForNow", type: WIDGET.TEXT },
                    { id: "spaceLG", type: WIDGET.SPACE }
                ],
                action: {
                    type: ACTION.REDIRECT_ACTION,
                    routeId: ROUTE.PAYMENT_CALLBACK
                }
            },
            skipPaymentForNow: {
                label: 'Skip for now',
                color: ColorTokens.Primary_100,
                fontSize: FontSizeTokens.SM,
                fontWeight: '600',
                paddingTop: 18,
                lineHeight: 18,
            },
            successNote: {
                width: StackWidth.FULL,
                type: StackType.row,
                bgColor: ColorTokens.Yellow_10,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR2
                },
                padding: {
                    left: SizeTypeTokens.XXL,
                    right: SizeTypeTokens.XXXXL,
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG
                },
                widgetItems: [
                    { id: 'noteText', type: WIDGET.TEXT },
                    { id: "spaceXS", type: WIDGET.SPACE },
                    { id: 'pCardText', type: WIDGET.TEXT },
                ],
            },
            noteText: {
                label: 'Note: ',
                fontSize: FontSizeTokens.XS,
                lineHeight: 16,
                fontWeight: '900',
            },
            pCardText: {
                label: 'It may take 1-2 business days for payment to reflect in the account statement.',
                fontSize: FontSizeTokens.XS,
                lineHeight: 16,
                fontWeight: '500',
            },
            failureNote: {
                failedTitle: " Any amount deducted from your account will be refunded to your account in 5-7 business days.",
                progressTitle: "Your repayment is being processed. Please wait while we confirm the status of your transaction.",
                status: isPaymentPending ? "Pending" : "Failed",
            },
        },
    };
};
export const paymentCallback = {
    onLoad: async ({ instrumentTrack, network, navigate, setDatastore, getHeight, removeWidgets }, { isPgCallback, collectionId, paymentCancelled, stopInterval, dspPaymentStatus, currentOrderId, redirectingRoute, setShowSupportPhoneNumber, setIsUserLoggedIn }) => {
        //to solve race conditon android and ios
        if ((Platform.OS === 'android' || Platform.OS === 'ios') && stopInterval) {
            stopInterval();
        }
        await removeWidgets(ROUTE.PAYMENT_CALLBACK, [
            { id: 'dspPaymentScreen', type: WIDGET.DSP_PAYMENT_SCREEN }
        ]);
        const userCollectionId = isPgCallback ? isPgCallback : collectionId;
        let user = await sharedPropsService.getUser();
        let currentLender = user?.linkedApplications[0]?.lenderAccountId;
        if (user === null || user === undefined) {
            const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
            currentLender = userContextResponse.data.linkedApplications[0].lenderAccountId;
            user = userContextResponse.data;
        }
        let userPaymentData;
        if (currentLender.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
            userPaymentData = await network.get(`${api.dspPaymentCallback}${userCollectionId}`, { headers: await getAppHeader() });
        }
        else {
            userPaymentData = await network.get(`${api.userPaymentData}${userCollectionId}`, { headers: await getAppHeader() });
        }
        const dspAmountCollected = userPaymentData?.data?.totalAmountDue;
        const epochDspPaymentDate = userPaymentData?.data?.lastUpdatedOn;
        Platform.OS === "web" ? removeUrlWithoutReload("uid") : {};
        Platform.OS === "web" ? removePathFromUrlWithouReload("pgCallBack") : {};
        if (currentLender?.toLowerCase() === LENDER_ID.DSP) {
            removeURLParams();
        }
        const paymentStatus = userPaymentData.data.collectionStatus;
        const showSupportPhoneNumber = await SharedPropsService.getSupportPhoneNumber();
        await SharedPropsService.setUser(user);
        if (Platform.OS === 'web') {
            setShowSupportPhoneNumber(showSupportPhoneNumber);
            setIsUserLoggedIn(user);
        }
        const isPaymentSuccessful = paymentStatus === PaymentStatuses.COLLECTION_COMPLETE || paymentStatus === PaymentStatuses.SETTLED || paymentStatus === PaymentStatuses.SUCCESS_WITH_LENDER_RECON_FAILED;
        const isPaymentFailure = paymentStatus === PaymentStatuses.FAILED;
        const isPaymentPending = paymentStatus === PaymentStatuses.PENDING_SETTLEMENT;
        const isPaymentCancelled = paymentCancelled ? paymentCancelled : paymentStatus === PaymentStatuses.CANCELLED;
        const amountCollected = paymentCancelled
            ? `₹${addCommasToNumber(Number(userPaymentData.data.totalAmountDue))}`
            : userPaymentData.data.actualAmountCollected !== null
                ? `₹${addCommasToNumber(Number(userPaymentData.data.actualAmountCollected))}`
                : "Not applicable";
        const isFromForeclosure = userPaymentData.data.collectionType;
        let isFromLoanRenewal = false;
        isFromLoanRenewal = userPaymentData.data.collectionType === REPAYMENT_COLLECTION_TYPE.LOAN_EXPIRED_DUE_REPAYMENT;
        const isFromInterestRepay = userPaymentData.data.collectionType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT;
        const isFromInterestCollection = userPaymentData.data.collectionType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION;
        const isFromShortfall = userPaymentData.data.collectionType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT;
        const transactionalRefNumber = userPaymentData.data.transactionId !== null ? userPaymentData.data.transactionId : "Not applicable";
        const bankName = userPaymentData.data.pgResponseDetails.bankName;
        const bankAccountNumber = userPaymentData.data.pgResponseDetails.bankAccountNumber;
        const bankRefNumber = userPaymentData.data.pgResponseDetails !== null && userPaymentData.data.pgResponseDetails.bankRefNo !== null
            ? userPaymentData.data.pgResponseDetails.bankRefNo
            : "Not applicable";
        const paymentMode = userPaymentData.data.pgResponseDetails !== null && userPaymentData.data.pgResponseDetails.paymentMode !== null
            ? userPaymentData.data.pgResponseDetails.paymentMode === "Unified Payments"
                ? "UPI"
                : userPaymentData.data.pgResponseDetails.paymentMode
            : "Not applicable";
        const epochFromBackend = userPaymentData.data.paymentDate;
        const dateFromBackend = new Date(userPaymentData.data.paymentDate);
        const dspPaymentDateRecieved = new Date(userPaymentData?.data?.lastUpdatedOn);
        const showDetailBanner = user?.linkedApplications[0]?.lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        const options = {
            timeZone: 'Asia/Calcutta',
            hour12: true,
            hour: 'numeric',
            minute: 'numeric',
        };
        //@ts-ignore
        const istTime = dateFromBackend.toLocaleString('en-US', options);
        //@ts-ignore
        const dspIstTime = dspPaymentDateRecieved.toLocaleString('en-US', options);
        const dspPaymentDate = epochDspPaymentDate !== null
            ? `${dspPaymentDateRecieved.toDateString()?.substring(4, dspPaymentDateRecieved.toDateString()?.length - 5)}, ${dspPaymentDateRecieved.toDateString()?.substring(dspPaymentDateRecieved.toDateString()?.length - 4)} ${dspIstTime}` : '';
        const paymentDate = epochFromBackend !== null
            ? `${dateFromBackend.toDateString().substring(4, dateFromBackend.toDateString().length - 5)}, ${dateFromBackend.toDateString().substring(dateFromBackend.toDateString().length - 4)} ${istTime}`
            : "";
        const settlementExpectedBy = userPaymentData?.data?.settlementExpectedBy;
        const paidViaMode = userPaymentData?.data?.pgResponseDetails?.paymentMode;
        if (paymentStatus === "SUCCESS_WITH_LENDER_RECON_FAILED") {
            await navigate(ROUTE.PAYMENT_IN_PROGRESS, {
                amount: amountCollected,
                date: paymentDate,
                refNumber: bankRefNumber,
                bankName: bankName,
                bankAccountNumber: bankAccountNumber
            });
        }
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Payment accepted for settlement",
                "verticalDescription": `Paid via ${paidViaMode === 'Unified Payments' ? 'UPI' : `${paidViaMode}`} on ${paymentDate}`,
                "order": 0
            },
            {
                "status": "IN_PROGRESS",
                "verticalDisplayName": `Settlement expected by ${getRepaymentExpectedDateBy(settlementExpectedBy)}`,
                "verticalDescription": `It may take up to 2 working days for the payment to reflect in the statement. Don’t worry, no additional interest will be charged.`,
                "order": 1
            },
        ];
        if (isPaymentSuccessful) {
            instrumentTrack("REPAYMENT_SUCCESS_PAGE_VIEWED");
        }
        return Promise.resolve(template(amountCollected, transactionalRefNumber, bankRefNumber, paymentMode, paymentDate, isPaymentSuccessful, isPaymentFailure, isPaymentPending, isPaymentCancelled, isFromForeclosure, showDetailBanner, isFromLoanRenewal, stepperData, getHeight(), currentLender, isFromInterestRepay, isFromInterestCollection, isFromShortfall, dspPaymentStatus, currentOrderId, dspAmountCollected, dspPaymentDate, redirectingRoute));
    },
    actions: {
        [ACTION.REDIRECT_ACTION]: redirectDashboard,
        [ACTION.RETRY_PAYMENT]: retryPayment,
        [ACTION.RETRY_PAYMENT_LOAN_EXPIRED]: retryPaymentForExpiredLoan,
        [ACTION.RETRY_PAYMENT_FORECLOSURE]: retryPaymentForeclosure,
        [ACTION.RETRY_INTEREST_COLLECTION_PAYMENT]: retryInterestCollectionPayment,
        [ACTION.RETRY_PAYMENT_SHORTFALL]: retryPaymentShortfall,
    },
    clearPrevious: true,
};
